module.exports = __webpack_public_path__ + "img/icon-menu-notes.c20083d5.svg";